import { render } from "./AddPrimaryStorage.vue?vue&type=template&id=5b52420e&scoped=true"
import script from "./AddPrimaryStorage.vue?vue&type=script&lang=js"
export * from "./AddPrimaryStorage.vue?vue&type=script&lang=js"

import "./AddPrimaryStorage.vue?vue&type=style&index=0&id=5b52420e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/cloudstack/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b52420e"]])

export default __exports__